import dayjs from 'dayjs';
import { DayjsOrNull } from 'interfaces/CustomTypes';

export const isRatePlanned = (startDatetime: DayjsOrNull | undefined) => {
  if (!startDatetime) return false;
  return dayjs(startDatetime).isSameOrAfter(dayjs());
};
